import React from 'react';
import { Check, X } from 'lucide-react';
const beforeItems = ['Horas planificando cada clase', 'Clases repetitivas', 'Sin profundidad filosófica', 'No saber qué cobrar', 'Alumnos que se van'];
const afterItems = ['5 minutos de repaso', '52 clases con variedad', 'Tema filosófico cada semana', 'Precios claros y confianza', 'Comunidad fiel'];
const bottomStats = [{
  num: '+52',
  label: 'Clases'
}, {
  num: '5',
  label: 'Tomos'
}, {
  num: '100%',
  label: 'Descargable'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-41">
      <div className="max-w-5xl mx-auto" data-id="element-42">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16" data-id="element-43">
          {/* Left side */}
          <div data-id="element-44">
            <h2 className="text-4xl sm:text-5xl font-serif font-black text-text-main mb-6 leading-tight" data-id="element-45">
              De una profesora sobrecargada a una{' '}
              <span className="text-primary italic" data-id="element-46">guía inspirada.</span>
            </h2>
            <div className="flex items-center gap-4 bg-bg-alt p-6 rounded-2xl border border-border-light shadow-sm inline-flex" data-id="element-47">
              <span className="text-5xl sm:text-6xl font-serif font-black text-secondary" data-id="element-48">
                150+
              </span>
              <p className="text-text-sec text-sm sm:text-base font-medium leading-snug max-w-[150px]" data-id="element-49">
                horas ahorradas al año en planificación.
              </p>
            </div>
          </div>

          {/* Right side - Comparison Table */}
          <div className="bg-bg-alt rounded-3xl border border-border-light overflow-hidden shadow-sm" data-id="element-50">
            <div className="grid grid-cols-2 divide-x divide-border-light" data-id="element-51">
              {/* Before */}
              <div className="p-6 sm:p-8 bg-red-50/30" data-id="element-52">
                <h3 className="text-secondary font-bold text-xs sm:text-sm uppercase tracking-wider mb-6 flex items-center gap-2" data-id="element-53">
                  <span className="w-6 h-6 rounded-full bg-secondary/10 flex items-center justify-center" data-id="element-54">
                    <X className="w-3 h-3" data-id="element-55" />
                  </span>
                  Antes
                </h3>
                <ul className="space-y-4" data-id="element-56">
                  {beforeItems.map((item, i) => <li key={i} className="text-text-sec text-sm sm:text-base flex items-start gap-2" data-id="element-57">
                      <X className="w-4 h-4 text-secondary/50 flex-shrink-0 mt-1" data-id="element-58" />
                      <span data-id="element-59">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* After */}
              <div className="p-6 sm:p-8 bg-primary/5" data-id="element-60">
                <h3 className="text-primary font-bold text-xs sm:text-sm uppercase tracking-wider mb-6 flex items-center gap-2" data-id="element-61">
                  <span className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-62">
                    <Check className="w-3 h-3" data-id="element-63" />
                  </span>
                  Con Yoga Lista
                </h3>
                <ul className="space-y-4" data-id="element-64">
                  {afterItems.map((item, i) => <li key={i} className="text-text-main font-medium text-sm sm:text-base flex items-start gap-2" data-id="element-65">
                      <Check className="w-4 h-4 text-primary flex-shrink-0 mt-1" data-id="element-66" />
                      <span data-id="element-67">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom stats */}
        <div className="grid grid-cols-3 gap-4 sm:gap-6 max-w-3xl mx-auto" data-id="element-68">
          {bottomStats.map((s, i) => <div key={i} className="bg-bg-alt border border-border-light rounded-2xl p-4 sm:p-6 text-center shadow-sm" data-id="element-69">
              <p className="text-primary font-serif font-black text-2xl sm:text-4xl mb-1" data-id="element-70">
                {s.num}
              </p>
              <p className="text-text-sec text-xs sm:text-sm font-medium uppercase tracking-wider" data-id="element-71">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}